<angular-template tag="div">
    <div class="vrm-filter_options__tags">
        <div ng-if="label" class="vrm-filter_options__tags__header">
            <p data-i18n="{{i18n ? i18n : label}}" />
        </div>
        <div class="vrm-tags__tag-search">
            <ui-select multiple tagging="disabledTagging" tagging-label="false" placeholder="tags" theme="select2" class="vrm-select sg-element vrm-tags--edit" ng-model="selectedTags.selected" on-select="addTag($item)" on-remove="removeTag($item)">
                <ui-select-match placeholder="Tags...">{{$item.id ? $item.id : $item}}</ui-select-match>
                <ui-select-choices repeat="item in options | filter: {label: $select.search}">
                    <span ng-bind="item.label"></span>
                </ui-select-choices>
            </ui-select>
        </div>
    </div>
</angular-template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component
@AngularLocaleBundle('installationoverview')
@AngularLocaleBundle('tags')
@AngularLocaleBundle('dashboard')
@AngularLocaleBundle('core')
export default class VrmInstallationOverviewFilterTagSearch extends Vue {
    @Prop({ type: Array, default: [] })
    options;
    @Prop({ type: String, default: '', required: false })
    label;
    @Prop({ type: String, default: undefined, required: false })
    i18n;

    // selectedTags has to be wrapped in an object due to a bug with ui-select reactivity
    selectedTags = { selected: [] };

    @Watch('options', { deep: true })
    onChange() {
        this.selectedTags.selected = this.options.filter(option => option.value);
        this.$emit('submit', null);
    }

    mounted() {
        this.onChange();
    }

    addTag(tag) {
        if (!Object.hasOwn(tag, 'value')) {
            return;
        }
        tag.value = true;
    }

    removeTag(tag) {
        tag.value = false;
    }
}
</script>
